import registerWebComp, { type WebCompProps } from '@helsenorge/framework-utils/web-component/register';

import { MicrowebSkjemaContents } from './cointainer';

const renderApp = (): void => {
  registerWebComp(MicrowebSkjemaContents as React.ComponentType<WebCompProps>, {
    name: 'hn-webcomp-skjema',
    templateId: 'hn-webcomp-skjema-template',
    properties: ['containerstyle'],
  });
};

if (import.meta.env.MODE === 'mocks') {
  import('../__mocks__/browser')
    .then(({ worker }) =>
      worker.start({
        onUnhandledRequest: 'bypass',
      })
    )
    .then(() => renderApp());
} else {
  renderApp();
}
